import React from "react";
import RichText from "components/rich-text";
import { ReactComponent as Lock } from "assets/svgs/lock.svg";
import useEmailSignup from "hooks/useEmailSignup";
import { getRgba } from "helpers/get-rgba";
import clsx from "clsx/lite";

const Newsletter = (props) => {
	const {
		content,
		listId,
		safetyText,
		buttonText,
		successMessage = "",
		placeholder = "",
		bgColor,
	} = props.data ?? {};

	const { success, email, error, handleSubscribe, onEmailChange } = useEmailSignup(listId);

	if (!props.data) return null;

	return (
		<div
			className="border-solid border-y-[0.06rem] border-[#E9E9E9] py-14 lg:mb-14 px-5 md:px-7"
			style={{ backgroundColor: getRgba(bgColor) }}>
			<div className="hd-screen-max-width">
				<div className="flex flex-col md:flex-row flex-wrap justify-between md:items-center">
					<div className="flex-1 mr-5 lg:max-w-xl text-left">
						<RichText value={content} />
					</div>
					<div className="mt-5">
						{success ? (
							<div className="lg:max-w-xl">
								<RichText value={successMessage} />
							</div>
						) : (
							<form
								onSubmit={handleSubscribe}
								className="flex flex-row box-border overflow-visible items-stretch max-h-14"
							>
								<div className="flex flex-grow flex-col self-end">
									<div>
										<label htmlFor={props.inputId}
											className="absolute left-[-10000px] top-auto w-1 h-1 overflow-hidden"
										>
											Enter your email
										</label>
										<input
											onChange={onEmailChange}
											id={props.inputId}
											autoComplete
											type="text"
											placeholder={`${placeholder ?? "Email..."}`}
											name="email"
											value={email}
											aria-required="true"
											aria-label={placeholder}
											className={`email-signup-input ${error ? "border-[#D0331F] focus:border-[#D0331F]" : ""}`}
										/>
									</div>
									{error && (
										<div className="relative w-full">
											<div className="absolute z-[1] right-0 rounded top-2.5">
												<div className="hover-error">
													<span>{error}</span>
												</div>
											</div>
										</div>
									)}
								</div>
								<button type="submit"
									className={clsx("email-signup-button whitespace-nowrap px-2 w-auto", email !== "" && "bg-black")}>
									{buttonText}
								</button>
							</form>
						)}
						<div className="flex items-baseline mt-4">
							<Lock className="mr-4" />
							<p className="text-base text-gray-700">{safetyText}</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Newsletter;